import { useQuery } from '@apollo/client';
import query from '../../queries/user';

export default function useUser() {
  const { data, ...rest } = useQuery(query);

  const user = data?.user;

  return {
    user,
    isAuthenticated: Boolean(user?.id),
    ...rest
  };
}
